import { Entidad } from "../../../data/Entidad";
import { _SvAlumnoDeshacerCalificaciones } from "../../../data/modulo/MateriaV2";
import _L from "../../../util/Labels";
import { _ModalInfoDataList } from "../../controlD3/ModalThings/ModalInfoDataList";
import { _ModalToAProccess } from "../../controlD3/ModalThings/ModalToAProccess";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { IAsignacionCalificacionActionHandler } from "../../panelCard/Alumno/AlumnosMaterias";
import { group } from "d3-array";

interface UndoQualifcationsArgs {
    idEscuela: number,
    repeticiones: Array<IAsignacionCalificacionActionHandler>,
    successCallback?: (asignacionesRevertStatusResponse: asignacionesRevertStatus[]) => void;
}

interface asignacionesRevertStatus {
    IdAsignacion: number;
    ParentAsignacion: IAsignacionCalificacionActionHandler["ParentAsignacion"];
    IdsCalificacionesRevert: number[];
    IdsCalificacionesInBoleta: number[];
    IdsCalificacionesError: number[];
}

export function _DeshacerCalificacion({ repeticiones, idEscuela, successCallback }: UndoQualifcationsArgs) {
    if (!repeticiones.length) {
        NotificacionV2._Mostrar(_L("general.notif_datanoproccesable"), "ADVERTENCIA");
        return;
    }

    _ModalToAProccess({
        Title: _L("panelalumnomaterias.action_undo_qualifications"),
        DrawContent: (content) => {
            content.append("label").text(_L("panelalumnomaterias.confirm_undo_qualifications"));
            content.append("br");
            content.append("br");
            content.append("label").text(_L("panelalumnomaterias.undo_qualifications_selection_note"));
        },
        Modulo: Entidad.CModulo.PanelAlumnoMaterias,
        Action: Entidad.CAccionPermiso.Eliminar,
        IdsEscuelas: [idEscuela],
        OnAccept: async (mt) => {
            interface IAsignacionInPlayGround {
                IdAsignacion: number;
                AsignacionData: IAsignacionCalificacionActionHandler["ParentAsignacion"];
                IdsCalificaciones: number[];
            }

            const asignacionesToProcess: IAsignacionInPlayGround[] = [];

            let completeRep: Array<IAsignacionCalificacionActionHandler> = [];
            interface IDeshacerCalificaciones {
                [idPadre: string]: number[];
            }

            repeticiones.forEach((d) => {
                completeRep.push({ ...d, Id: d.Id, ParentAsignacion: { ...d.ParentAsignacion, IdAsignacion: d.ParentAsignacion.IdAsignacion } })
            })

            let repeticionesGroupedByParent = group(completeRep, d => d.ParentAsignacion.IdAsignacion);
            let objAsignacionesRevert: IDeshacerCalificaciones = {};

            repeticionesGroupedByParent.forEach((asignaciones, agrupador) => {
                objAsignacionesRevert[agrupador] = [];
                if (asignaciones[0].isMaster) {
                    objAsignacionesRevert[agrupador] = null;
                    asignacionesToProcess.push({ IdAsignacion: agrupador, AsignacionData: asignaciones[0].ParentAsignacion, IdsCalificaciones: [] })
                    return;
                }

                objAsignacionesRevert[agrupador].push(...asignaciones.map(d => d.Id));
                asignacionesToProcess.push({ IdAsignacion: agrupador, AsignacionData: asignaciones[0].ParentAsignacion, IdsCalificaciones: asignaciones.map(d => d.Id) })
            })

            let res = await _SvAlumnoDeshacerCalificaciones(objAsignacionesRevert)

            console.log(asignacionesToProcess);

            const asignacionesStatusArr: asignacionesRevertStatus[] = [];

            for (const asignacion of asignacionesToProcess) {
                let asignacionInRes = (res.Datos || []).find(d => d.IdAsignacion == asignacion.IdAsignacion);
                if (!asignacionInRes) {
                    asignacionesStatusArr.push({
                        IdAsignacion: asignacion.IdAsignacion,
                        ParentAsignacion: asignacion.AsignacionData,
                        IdsCalificacionesRevert: [],
                        IdsCalificacionesInBoleta: [],
                        IdsCalificacionesError: [],
                    });
                    continue;
                }

                let asignInfo: asignacionesRevertStatus = {
                    IdAsignacion: asignacion.IdAsignacion,
                    IdsCalificacionesRevert: asignacionInRes.IdsCalificacionesRevert,
                    IdsCalificacionesInBoleta: asignacionInRes.IdsCalificacionesEnBoleta,
                    IdsCalificacionesError: [],
                    ParentAsignacion: asignacion.AsignacionData,
                };

                if (!asignacion.IdsCalificaciones.length) {
                    asignacionesStatusArr.push(asignInfo);
                    continue;
                }
                asignacion.IdsCalificaciones.forEach(d => {
                    if (!asignInfo.IdsCalificacionesRevert.includes(d) && !asignInfo.IdsCalificacionesInBoleta.includes(d)) {
                        asignInfo.IdsCalificacionesError.push(d);
                    }
                })
                asignacionesStatusArr.push(asignInfo);
            }

            _ModalInfoDataList({
                Title: _L("general.resumen"),
                DataList: asignacionesStatusArr,
                InfoText: _L("panelalumnomaterias.actions_resume_byassigment"),
                OnStepItemData: (content, resumenItem) => {
                    let tag = CreateResponseSummary(resumenItem);
                    content.html(tag);
                },
                OnClose() {
                    if (res.Resultado > 0) {
                        successCallback && successCallback(asignacionesStatusArr);
                    }
                },
            })

            mt.Modal._Ocultar();
            return null;
        },
    })
}

function CreateResponseSummary(resumenItem: asignacionesRevertStatus): string {
    let strRedColor = `var(--color_app_red1)`;
    let strGreenColor = `var(--color_app_green1)`;
    let tag = ``;
    if (resumenItem.ParentAsignacion.Criterio) {
        tag = `<b>${resumenItem.ParentAsignacion.Criterio}</b>`;
        tag += `<br>`;
        tag += `<i style='font-size: var(--fontsize_me4);'>${resumenItem.ParentAsignacion.NombreMateria} - ${resumenItem.ParentAsignacion.StrGrupo}</i>`;
    } else {
        tag = `<b style='font-size: var(--fontsize_me2);'>${resumenItem.ParentAsignacion.NombreMateria} - ${resumenItem.ParentAsignacion.StrGrupo}</b>`;
    }

    if (!resumenItem.IdsCalificacionesRevert.length && !resumenItem.IdsCalificacionesInBoleta.length && !resumenItem.IdsCalificacionesError.length) {
        tag += `<br>`;
        tag += `<i style='font-size: var(--fontsize_me4); color: ${strRedColor};'>${_L("general.notif_fail")}</i>`;
        return tag;
    }
    if (resumenItem.IdsCalificacionesRevert.length) {
        tag += `<br>`;
        tag += `<i style='font-size: var(--fontsize_me4); color: ${strGreenColor};'>${_L("panelalumnomaterias.tag_reverted_qualifications")}: ${resumenItem.IdsCalificacionesRevert.length}</i>`;
    }
    if (resumenItem.IdsCalificacionesInBoleta.length) {
        tag += `<br>`;
        tag += `<i style='font-size: var(--fontsize_me4); color: ${strRedColor};'>${_L("panelalumnomaterias.tag_inreport_qualifications")}: ${resumenItem.IdsCalificacionesInBoleta.length}</i>`;
    }
    if (resumenItem.IdsCalificacionesError.length) {
        tag += `<br>`;
        tag += `<i style='font-size: var(--fontsize_me4); color: ${strRedColor};'>${_L("panelalumnomaterias.tag_none_or_reverted_qualifications")}: ${resumenItem.IdsCalificacionesError.length}</i>`;
    }
    return tag
}